<template>
  <div class="staff-manage">
    <!-- 搜索区域 -->
    <el-card class="search-card">
      <el-form :model="searchForm" class="search-form" inline>
        <el-form-item label="员工姓名">
          <el-input v-model="searchForm.realname" placeholder="请输入员工姓名" clearable></el-input>
        </el-form-item>
        <el-form-item label="用户名">
          <el-input v-model="searchForm.username" placeholder="请输入用户名" clearable></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="searchForm.mobile" placeholder="请输入手机号" clearable></el-input>
        </el-form-item>
        <el-form-item label="角色">
          <el-select v-model="searchForm.role" placeholder="请选择角色" clearable>
            <el-option
              v-for="role in roleList"
              :key="role.role"
              :label="role.name"
              :value="role.role"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="searchForm.disabled" placeholder="请选择状态" clearable>
            <el-option label="启用" :value="false"></el-option>
            <el-option label="禁用" :value="true"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">搜索</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 操作区域 -->
    <el-card class="operation-card">
      <el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增员工</el-button>
    </el-card>

    <!-- 表格区域 -->
    <el-card class="table-card">
      <el-table :data="tableData" v-loading="loading" border>
        <el-table-column prop="role_id" label="Role" width="80"></el-table-column>
        <el-table-column prop="username" label="用户名" min-width="120"></el-table-column>
        <el-table-column prop="realname" label="真实姓名" min-width="160"></el-table-column>
        <el-table-column prop="email" label="邮箱" min-width="180" show-overflow-tooltip></el-table-column>
        <el-table-column prop="mobile" label="手机号" width="180"></el-table-column>
        <el-table-column prop="created_at" label="注册日期" width="180">
          <template slot-scope="scope">
            {{ formatDate(scope.row.created_at) }}
          </template>
        </el-table-column>
        <el-table-column prop="created_ip" label="注册IP" width="160"></el-table-column>
        <el-table-column prop="disabled" label="状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="!scope.row.disabled ? 'success' : 'danger'">
              {{ !scope.row.disabled ? '启用' : '禁用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="250">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleView(scope.row)">查看</el-button>
            <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button type="text" size="small" @click="handleResetPassword(scope.row)">修改密码</el-button>
            <el-button type="text" size="small" style="color: #f56c6c" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-wrapper">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.currentPage"
          :page-sizes="[10, 15, 20, 25]"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        ></el-pagination>
      </div>
    </el-card>

    <!-- 新增/编辑对话框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="600px"
      @close="handleDialogClose"
    >
      <el-form :model="formData" :rules="formRules" ref="form" label-width="100px">
        <el-form-item label="用户名" prop="username">
          <el-input v-model="formData.username" placeholder="请输入用户名" :disabled="isView || isEdit"></el-input>
        </el-form-item>
        <el-form-item label="真实姓名" prop="realname">
          <el-input v-model="formData.realname" placeholder="请输入真实姓名" :disabled="isView"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password" v-if="!isEdit && !isView">
          <el-input v-model="formData.password" type="password" placeholder="请输入密码" show-password></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword" v-if="!isEdit && !isView">
          <el-input v-model="formData.confirmPassword" type="password" placeholder="请再次输入密码" show-password></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="formData.email" placeholder="请输入邮箱" :disabled="isView"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="mobile">
          <el-input v-model="formData.mobile" placeholder="请输入手机号" :disabled="isView"></el-input>
        </el-form-item>
        <el-form-item label="角色" prop="role">
          <el-select v-model="formData.role" placeholder="请选择角色" :disabled="isView" style="width: 100%">
            <el-option
              v-for="role in roleList"
              :key="role.role"
              :label="role.name"
              :value="role.role"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态" prop="disabled">
          <el-radio-group v-model="formData.disabled" :disabled="isView">
            <el-radio :label="false">启用</el-radio>
            <el-radio :label="true">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" v-if="!isView">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="submitLoading">确定</el-button>
      </div>
    </el-dialog>

    <!-- 重置密码对话框 -->
    <el-dialog
      title="修改密码"
      :visible.sync="resetPasswordDialogVisible"
      width="400px"
    >
      <el-form :model="resetPasswordForm" :rules="resetPasswordRules" ref="resetPasswordForm" label-width="100px">
        <el-form-item label="新密码" prop="newPassword">
          <el-input v-model="resetPasswordForm.newPassword" type="password" placeholder="请输入新密码" show-password></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input v-model="resetPasswordForm.confirmPassword" type="password" placeholder="请再次输入新密码" show-password></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetPasswordDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleConfirmResetPassword" :loading="resetPasswordLoading">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from "@/lib/request";

export default {
  name: 'StaffManage',
  data() {
    return {
      // 搜索表单
      searchForm: {
        realname: '',
        username: '',
        mobile: '',
        role: '',
        disabled: ''
      },
      // 表格数据
      tableData: [],
      loading: false,
      // 角色列表
      roleList: [],
      // 分页
      pagination: {
        currentPage: 1,
        pageSize: 15,
        total: 0
      },
      // 对话框相关
      dialogVisible: false,
      dialogTitle: '新增员工',
      dialogMode: 'add', // add, edit, view
      formData: {
        id: null,
        username: '',
        realname: '',
        password: '',
        confirmPassword: '',
        email: '',
        mobile: '',
        role: '',
        disabled: false
      },
      formRules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 3, max: 20, message: '用户名长度在 3 到 20 个字符', trigger: 'blur' }
        ],
        realname: [
          { required: true, message: '请输入真实姓名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, max: 20, message: '密码长度在 6 到 20 个字符', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请再次输入密码', trigger: 'blur' },
          { validator: this.validateConfirmPassword, trigger: 'blur' }
        ],
        email: [
          { type: 'email', message: '请输入正确的邮箱格式', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
        ],
        role: [
          { required: true, message: '请选择角色', trigger: 'change' }
        ]
      },
      submitLoading: false,
      // 重置密码相关
      resetPasswordDialogVisible: false,
      resetPasswordForm: {
        newPassword: '',
        confirmPassword: ''
      },
      resetPasswordRules: {
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, max: 20, message: '密码长度在 6 到 20 个字符', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' },
          { validator: this.validateResetConfirmPassword, trigger: 'blur' }
        ]
      },
      resetPasswordLoading: false,
      currentStaffId: null
    }
  },
  computed: {
    isEdit() {
      return this.dialogMode === 'edit'
    },
    isView() {
      return this.dialogMode === 'view'
    }
  },
  mounted() {
    this.loadData()
    this.loadRoleList()
  },
  methods: {
    // 格式化日期
    formatDate(dateStr) {
      if (!dateStr) return ''
      const date = new Date(dateStr)
      return date.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      })
    },

    // 确认密码验证
    validateConfirmPassword(rule, value, callback) {
      if (value !== this.formData.password) {
        callback(new Error('两次输入的密码不一致'))
      } else {
        callback()
      }
    },

    // 重置密码确认验证
    validateResetConfirmPassword(rule, value, callback) {
      if (value !== this.resetPasswordForm.newPassword) {
        callback(new Error('两次输入的密码不一致'))
      } else {
        callback()
      }
    },

    // 搜索
    handleSearch() {
      this.pagination.currentPage = 1
      this.loadData()
    },

    // 重置
    handleReset() {
      this.searchForm = {
        realname: '',
        username: '',
        mobile: '',
        role: '',
        disabled: ''
      }
      this.pagination.currentPage = 1
      this.loadData()
    },

    // 新增
    handleAdd() {
      this.dialogTitle = '新增员工'
      this.dialogMode = 'add'
      this.formData = {
        id: null,
        username: '',
        realname: '',
        password: '',
        confirmPassword: '',
        email: '',
        mobile: '',
        role: '',
        disabled: false
      }
      this.dialogVisible = true
    },

    // 查看
    handleView(row) {
      this.dialogTitle = '查看员工'
      this.dialogMode = 'view'
      this.loadStaffInfo(row.id)
      this.dialogVisible = true
    },

    // 编辑
    handleEdit(row) {
      this.dialogTitle = '编辑员工'
      this.dialogMode = 'edit'
      this.loadStaffInfo(row.id)
      this.dialogVisible = true
    },

    // 加载员工详情
    async loadStaffInfo(id) {
      try {
        const response = await axios.request({
          url: '/v1/admin/cmn/employee/info',
          method: 'get',
          params: { id }
        })
        
        if (response && response.err_code === 0) {
          const data = response.data
          this.formData = {
            id: data.id,
            username: data.username,
            realname: data.realname,
            email: data.email,
            mobile: data.mobile,
            role: data.role_id,
            disabled: data.disabled
          }
        }
      } catch (error) {
        this.$message.error('获取员工信息失败')
      }
    },

    // 重置密码
    handleResetPassword(row) {
      this.currentStaffId = row.id
      this.resetPasswordForm = {
        id: row.id,
        newPassword: '',
        confirmPassword: ''
      }
      this.resetPasswordDialogVisible = true
    },

    // 确认重置密码
    async handleConfirmResetPassword() {
      this.$refs.resetPasswordForm.validate(async (valid) => {
        if (valid) {
          try {
            this.resetPasswordLoading = true
            const response = await axios.request({
              url: '/v1/admin/cmn/employee/update',
              method: 'post',
              data: {
                id: this.resetPasswordForm.id,
                password: this.resetPasswordForm.newPassword
              }
            })
            
            if (response && response.err_code === 0) {
              this.$message.success('密码修改成功')
              this.resetPasswordDialogVisible = false
              this.resetPasswordForm = {
                id: '',
                newPassword: '',
                confirmPassword: ''
              }
            }
          } catch (error) {
            this.$message.error('密码修改失败')
          } finally {
            this.resetPasswordLoading = false
          }
        }
      })
    },

    // 删除员工
    async handleDelete(row) {
      this.$confirm('确定要删除该员工吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const response = await axios.request({
            url: '/v1/admin/cmn/employee/delete',
            method: 'get',
            params: { id: row.id }
          })
          
          if (response && response.err_code === 0) {
            this.$message.success('删除成功')
            this.loadData()
          }
        } catch (error) {
          this.$message.error('删除失败')
        }
      })
    },

    // 提交表单
    async handleSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            let response
            const data = { ...this.formData }
            
            if (this.dialogMode === 'add') {
              response = await axios.request({
                url: '/v1/admin/cmn/employee/add',
                method: 'post',
                data
              })
            } else {
              response = await axios.request({
                url: '/v1/admin/cmn/employee/edit',
                method: 'post',
                data
              })
            }
            
            if (response && response.err_code === 0) {
              this.$message.success(this.dialogMode === 'add' ? '新增成功' : '编辑成功')
              this.dialogVisible = false
              this.loadData()
            }
          } catch (error) {
            this.$message.error(this.dialogMode === 'add' ? '新增失败' : '编辑失败')
          }
        }
      })
    },

    // 加载数据
    async loadData() {
      this.loading = true
      try {
        const params = {
          page: this.pagination.currentPage,
          rows: this.pagination.pageSize
        }
        
        // 添加搜索条件
        if (this.searchForm.realname) {
          params.realname = this.searchForm.realname
        }
        if (this.searchForm.username) {
          params.username = this.searchForm.username
        }
        if (this.searchForm.mobile) {
          params.mobile = this.searchForm.mobile
        }
        if (this.searchForm.role) {
          params.role = this.searchForm.role
        }
        if (this.searchForm.disabled !== '') {
          params.disabled = this.searchForm.disabled
        }
        
        const response = await axios.request({
          url: '/v1/admin/cmn/employee/list',
          method: 'get',
          params
        })
        
        if (response && response.err_code === 0) {
          this.tableData = response.rows || []
          this.pagination.total = response.total || 0
        }
      } catch (error) {
        this.$message.error('获取数据失败')
      } finally {
        this.loading = false
      }
    },

    // 加载角色列表
    async loadRoleList() {
      try {
        const response = await axios.request({
          url: '/v1/admin/cmn/role/list',
          method: 'get',
          params: {only_admin:true}
        })
        
        if (response && response.err_code === 0) {
          this.roleList = response.rows || []
        }
      } catch (error) {
        console.error('获取角色列表失败:', error)
      }
    },

    // 分页
     handleSizeChange(val) {
       this.pagination.pageSize = val
       this.loadData()
     },
     
     handleCurrentChange(val) {
       this.pagination.currentPage = val
       this.loadData()
     },

     // 关闭对话框
     handleDialogClose() {
       if (this.$refs.form) {
         this.$refs.form.resetFields()
       }
     }
  }
}
</script>

<style scoped>
.staff-manage {
  padding: 20px;
}

.search-card,
.operation-card,
.table-card {
  margin-bottom: 20px;
}

.search-form {
  margin-bottom: 0;
}

.pagination-wrapper {
  margin-top: 20px;
  text-align: right;
}
</style>